<script setup lang="ts">
// Banner do Clube de Fidelidade na sidebar (substitui o Giratudo quando a
// flag `club_fidelidade_active` está ligada). O banner.png já traz o brasão
// vazando pra cima dentro da própria arte; as estrelas são webps soltos
// ancorados por cima, cada um com flutuação própria.

const emit = defineEmits<{
  click: [];
}>();

interface BannerStar {
  id: number;
  top: string;
  left?: string;
  right?: string;
  width: string;
  rot: string;
  dur: string;
  delay: string;
}

// Posições espelham a arte de referência: estrela grande na borda esquerda,
// a borrada vazando o canto superior direito e as pequenas nas beiradas de
// baixo. `rot` é a amplitude de rotação da flutuação (sinal alterna o lado
// pra vizinhas não balançarem em fase).
const stars: BannerStar[] = [
  {
    id: 1,
    top: '10%',
    left: '0%',
    width: '20%',
    rot: '6deg',
    dur: '2.3s',
    delay: '0s',
  },
  {
    id: 2,
    top: '56%',
    left: '10%',
    width: '11%',
    rot: '-8deg',
    dur: '1.9s',
    delay: '-0.9s',
  },
  {
    id: 3,
    top: '55%',
    right: '3%',
    width: '12%',
    rot: '7deg',
    dur: '2.75s',
    delay: '-1.7s',
  },
  {
    id: 4,
    top: '1%',
    right: '9%',
    width: '18%',
    rot: '-5deg',
    dur: '2.5s',
    delay: '-2.2s',
  },
];
</script>

<template>
  <div
    class="loyalty-banner"
    @click="emit('click')"
  >
    <NuxtImg
      alt="Clube de Fidelidade"
      class="loyalty-banner-img"
      draggable="false"
      :src="getAssetsUrlForCDN('/assets/images/loyalty-hub/sidebar/banner.png')"
    />
    <NuxtImg
      v-for="star in stars"
      :key="star.id"
      alt=""
      aria-hidden="true"
      class="loyalty-banner-star"
      draggable="false"
      :src="
        getAssetsUrlForCDN(
          `/assets/images/loyalty-hub/sidebar/star-${star.id}.webp`,
        )
      "
      :style="{
        top: star.top,
        left: star.left,
        right: star.right,
        width: star.width,
        '--star-rot': star.rot,
        animationDuration: star.dur,
        animationDelay: star.delay,
      }"
    />
  </div>
</template>

<style scoped lang="scss">
.loyalty-banner {
  @apply mx-[15px] mt-1 cursor-pointer relative;

  @media (hover: hover) {
    &:hover {
      filter: brightness(1.1);
    }
  }

  .loyalty-banner-img {
    @apply w-full block pointer-events-none select-none;
    aspect-ratio: 512 / 315;
    height: auto;
  }

  .loyalty-banner-star {
    @apply absolute pointer-events-none select-none;
    height: auto;
    z-index: 1;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.35));
    /* O main.scss zera `transition` globalmente — movimento aqui é animation. */
    animation: loyalty-star-float 4s ease-in-out infinite alternate;
    will-change: transform;
  }

  @media (prefers-reduced-motion: reduce) {
    .loyalty-banner-star {
      animation: none;
    }
  }
}

@keyframes loyalty-star-float {
  from {
    transform: translateY(-3%) rotate(calc(var(--star-rot, 6deg) * -1));
  }

  to {
    transform: translateY(6%) rotate(var(--star-rot, 6deg));
  }
}
</style>
